<script lang="ts" setup>
import LinkButton from "@/components/buttons/LinkButton.vue";
import { useI18n } from "vue-i18n";
import OmniTooltip from "@/components/omni/OmniTooltip.vue";
import { computed } from "vue";
import { useBaseView } from "@/composables";
import { DispatcherPermissionValue } from "@/api/dto/dispatcher.dto";
import type { RouteLocationRaw } from "vue-router";

const { t } = useI18n();
const { hasAccess } = useBaseView();

const hasAccessToCreate = computed(() => {
  return hasAccess(DispatcherPermissionValue.EditOrCreateCompany);
});

defineProps<{
  to: RouteLocationRaw;
}>();
</script>

<template>
  <omni-tooltip :disabled="hasAccessToCreate">
    <template #activator>
      <link-button :disabled="!hasAccessToCreate" :to="to" color="success">
        {{ t("general.create-new") }}
      </link-button>
    </template>

    {{ t("permission.create-company") }}
  </omni-tooltip>
</template>
